import type { AvailabilityQuery, AvailabilityStatus } from "./flow";

/** The status an availability response carries, or "unknown" for anything
 * else: an answer this version cannot read is treated as in area, and the
 * server decides. */
export function parseAvailability(raw: unknown): AvailabilityStatus {
  if (typeof raw !== "object" || raw === null) return "unknown";
  const status = (raw as Record<string, unknown>).status;
  return status === "in_area" || status === "out_of_area" ? status : "unknown";
}

export function availabilityPath(query: AvailabilityQuery): string {
  const params = new URLSearchParams({
    zip: query.zip,
    segment: query.segment,
  });
  return `/leads/availability?${params.toString()}`;
}
